import React from 'react';

export const SettingsCard: React.FC = ({children}) => {
  return (
    <div className="mb-32 rounded-lg border border-moon-250 bg-white px-32 py-24">
      {children}
    </div>
  );
};
